import { render, staticRenderFns } from "./ShowAllItems.vue?vue&type=template&id=59489c1b&scoped=true"
import script from "./ShowAllItems.vue?vue&type=script&lang=ts"
export * from "./ShowAllItems.vue?vue&type=script&lang=ts"
import style0 from "./ShowAllItems.vue?vue&type=style&index=0&id=59489c1b&prod&lang=css"
import style1 from "./ShowAllItems.vue?vue&type=style&index=1&id=59489c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59489c1b",
  null
  
)

export default component.exports